import React from 'react'
const ActionsButtons = ({ text, action, active }: any): React.ReactElement => {

    return (
        <button className={"btn btn-shadow p-2 " + (active ? 'btn-primary ' : 'btn-outlined-primary butn')} onClick={action}>
            {text}
        </button>
    )
}
export default ActionsButtons
